import TemplateList from './TemplateList';

export default TemplateList;
